export default [
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      requiresAuth: true,
      title: 'Painel'
    },
    component: () =>
      import(/* webpackChunkName: "profile" */ '@/components/Dashboard.vue')
  }
]
